<script setup>
import Jumbo from '@/components/Docs/Jumbo.vue'
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'

</script>

<template>
  <div class="wrap row">
    <jumbo title="Threat News">
Threat intelligence is a vital component of any company’s cybersecurity strategy, encompassing the collection, analysis, and dissemination of information regarding potential cybersecurity threats. It provides organizations with actionable insights into emerging threats, enabling proactive defense measures and risk mitigation strategies. Threat intelligence sources include a wide range of data feeds, such as malware signatures, suspicious IP addresses, known attack patterns, and hacker forums. By leveraging threat intelligence, organizations can enhance their ability to detect, prevent, and respond to cyber attacks effectively, thereby safeguarding their assets, data, and reputation in an increasingly hostile digital landscape.
    </jumbo>


    <doc-section title="Latest articles">
      <template v-slot:left>
Articles are listed using a search pattern, an offset, and a list of tags. On any query the latest 30 articles are listed starting from the offset. 
<br><br>
The default way to list articles, is to use a query of none, that is no full text matching, an offset of 0, indicating starting from the latest entry, and the tag “Has Tags”. There are a lot of non relevant articles in the feed, so to filter off those, it is recommended to use the tag “Has Tags” or a list of specific tags. Full text search is also an option.
<br><br>
See Find articles for more information.
      </template>

      <template v-slot:right>
        <code-block title="/articles/search/none/0/Has%20Tag" method="GET">
          curl -X GET "https://api.webscout.io/articles/search/none/0/Has%20Tag"
        </code-block>

        <json-block title="Response">
{"data":[{"Id":"7f0d558d-333c-4fed-a53b-c510504bc999","Title":"US Government to Investigate Change Healthcare Ransomware Attack","Summary":"The US government will investigate whether protected healthcare information was breached in the Change Healthcare ransomware attack, and if the firm complied with HIPAA rules\n","Url":"https://www.infosecurity-magazine.com/news/us-investigate-healthcare/","OwnerDisplayName":"Infosecurity Magazine","PublishDate":"2024-03-14T14:45:00Z","UpdateDate":"0001-01-01T00:00:00Z","NumIndicators":0,"Tags":["Crime","Malware"]}],"status":"success"}
        </json-block>
      </template>
    </doc-section>


    <doc-section title="Find relevant articles">
      <template v-slot:left>

To find relevant articles, or remove irrelevant ones. You can utilize the 3 parameters: query, offset and tags.
<br><br>
The query can be any valid url encoded string. We use full text search, and the returned articles are ranked in the order of relevance.
<br><br>
The offset can be any valid positive integer, if the response returns with 0 results you know you have seen all matching articles. This allows you to cursor through the full result, when more than 30 relevant articles are found.
<br><br>
Tags is the last part of the url, and is a comma separated list of case sensitive strings. The available tags are the following:
<ul>
  <li>Hacktivism</li>
  <li>Espionage</li>
  <li>Vulnerability</li>
  <li>Malware</li>
  <li>Leak</li>
  <li>Patch</li>
  <li>Privacy</li>
  <li>Has Tag</li>
  <li>No Tag</li>
</ul>
      </template>

      <template v-slot:right>
        <code-block title="/articles/search/:query/:offset/:tags" method="GET">
          curl -X GET "https://api.webscout.io/articles/search/&lt;QUERY&gt;/&lt;OFFSET&gt;/&lt;TAGS&gt;"
        </code-block>

        <code-block title="Articles tagged with Breach and Crime and ranked according to 'windows system'">
          https://api.webscout.io/articles/search/windows%20system/0/Breach,Crime
        </code-block>

        <json-block title="Response">
{"data":[{"Id":"7f0d558d-333c-4fed-a53b-c510504bc999","Title":"US Government to Investigate Change Healthcare Ransomware Attack","Summary":"The US government will investigate whether protected healthcare information was breached in the Change Healthcare ransomware attack, and if the firm complied with HIPAA rules\n","Url":"https://www.infosecurity-magazine.com/news/us-investigate-healthcare/","OwnerDisplayName":"Infosecurity Magazine","PublishDate":"2024-03-14T14:45:00Z","UpdateDate":"0001-01-01T00:00:00Z","NumIndicators":0,"Tags":["Crime","Malware"]}],"status":"success"}
        </json-block>
      </template>
    </doc-section>

    <doc-section title="Get article indicators">
      <template v-slot:left>
        We make a best effort to extract indicators from the articles. For the time being this is an inaccurate process, and the extracted indicators should be verified manually against the articles. 
        <br><br>
The indicators can be found by querying the /articles/:id/indicators endpoint using the article’s id found in any listing of articles.

      </template>

      <template v-slot:right>
        <code-block title="/articles/:id/indicators" method="GET">
          curl -X GET "https://api.webscout.io/articles/&lt;ARTICLE_ID&gt;/indicators"
        </code-block>

        <json-block title="Response">
{"data":[{"Indicator":"cve-2023-48788","Type":200},{"Indicator":"cve-2024-0799","Type":200},{"Indicator":"cve-2024-0800","Type":200},{"Indicator":"ai.orizon3","Type":3},{"Indicator":"com.isk","Type":3}],"status":"success"}
        </json-block>
      </template>
    </doc-section>
  </div>
</template>

<style scoped>
.wrap {
  height: 100%;
  overflow-y: scroll;
}

.wrap > * {
  margin-top: 2.5rem;
}
.wrap > *:not(:first-child) {
  border-top: 2px solid #1e252f;
  padding-top: 2.5rem;
}
</style>
